var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47173 10.445C8.61716 10.2996 8.73253 10.127 8.81124 9.93707C8.88995 9.74711 8.93046 9.5435 8.93046 9.33788C8.93046 9.13225 8.88995 8.92864 8.81124 8.73868C8.73253 8.54872 8.61716 8.37612 8.47173 8.23075L6.81079 6.57066C6.66542 6.42523 6.49282 6.30987 6.30285 6.23116C6.11288 6.15245 5.90926 6.11194 5.70363 6.11194C5.498 6.11194 5.29438 6.15245 5.10441 6.23116C4.91444 6.30987 4.74184 6.42523 4.59647 6.57066L3.68538 7.48171C3.30356 7.86462 3.06561 8.36756 3.0117 8.9056C2.95779 9.44364 3.09124 9.98379 3.38951 10.4348C6.07112 14.4692 9.53037 17.9284 13.5649 20.6099C14.0163 20.9086 14.557 21.0423 15.0956 20.9883C15.6341 20.9342 16.1375 20.6957 16.5205 20.3132L17.4316 19.4022C17.725 19.1086 17.8899 18.7105 17.8899 18.2954C17.8899 17.8804 17.725 17.4823 17.4316 17.1887L15.7706 15.5286C15.4771 15.2351 15.079 15.0703 14.6639 15.0703C14.2488 15.0703 13.8506 15.2351 13.5571 15.5286L13.0037 16.082C11.1472 14.5547 9.44336 12.8508 7.916 10.9945L8.47173 10.445Z",
    fill: "#808080",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1728 10.827L21 3",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2621 10.8262H13.1744V5.73865",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCall);
export default __webpack_public_path__ + "static/media/incoming-call.aaaf0cb6c27e80d151d140aa8f7fda76.svg";
export { ForwardRef as ReactComponent };